import { IContextualMenuItem } from '@fluentui/react';

const def: Array<IContextualMenuItem> = [
  {
    key: 'today',
    text: "Today's date",
  },
  {
    key: 'companyName',
    text: 'Company name',
  },
];

const companyAddressMenu: Array<IContextualMenuItem> = [
  {
    key: 'companyAddressSubMenu',
    subMenuProps: {
      items: [
        { key: 'companyName', text: 'Company Name' },
        { key: 'companyAddressLine1', text: 'Address Line 1' },
        { key: 'companyAddressLine2', text: 'Address Line 2' },
        { key: 'companyAddressLine3', text: 'Address Line 3' },
        { key: 'companyAddressLine4', text: 'Address Line 4' },
        { key: 'companyAddressLine5', text: 'Address Line 5' },
        { key: 'companyAddressPostcode', text: 'Post Code' },
        { key: 'companyAddressCountry', text: 'Country' },
      ],
    },
    text: 'Company Address',
  },
];

const systemMenu: Array<IContextualMenuItem> = [
  {
    key: 'systemSubMenu',
    subMenuProps: {
      items: [
        { key: 'today', text: 'System Date' },
        { key: 'currentUserName', text: 'Users Name' },
        { key: 'jobTitle', text: 'Job Title' },
      ],
    },
    text: 'System',
  },
];

export const emailFooter: Array<IContextualMenuItem> = [...def, ...companyAddressMenu, ...systemMenu];

export const document: Array<IContextualMenuItem> = [
  ...def,
  {
    key: 'documentNumber',
    text: 'Document Number',
  },
  {
    key: 'documentSuffix',
    text: 'Document Suffix',
  },
  {
    key: 'documentDate',
    text: 'Document Date',
  },
];

export const customerDocument: Array<IContextualMenuItem> = [
  ...document,
  {
    key: 'customerReference',
    text: 'Customer Reference',
  },
  {
    key: 'customerName',
    text: 'Customer Name',
  },
  {
    key: 'customerAccountBalance',
    text: 'Customer Account Balance',
  },
  {
    key: 'contactName',
    text: 'Delivery Contact Name',
  },
  {
    key: 'contactPhone',
    text: 'Delivery Contact phone',
  },
  {
    key: 'contactMobile',
    text: 'Delivery Contact Mobile',
  },
  {
    key: 'contactTitle',
    text: 'Delivery Contact Title',
  },
  {
    key: 'contactFirstName',
    text: 'Delivery Contact First Name',
  },
  {
    key: 'contactMiddleNames',
    text: 'Delivery Contact Middle Name(s)',
  },
  {
    key: 'contactLastName',
    text: 'Delivery Contact Last Name',
  },
];

export const customerContactDocument: Array<IContextualMenuItem> = [
  { key: 'name.title', text: 'Title' },
  { key: 'name.firstName', text: 'First Name' },
  { key: 'name.middleName', text: 'Middle Name' },
  { key: 'name.lastName', text: 'Last Name' },
  {
    key: 'contactAddressSubMenu',
    subMenuProps: {
      items: [
        { key: 'address.line1', text: 'Address Line 1' },
        { key: 'address.line2', text: 'Address Line 2' },
        { key: 'address.line3', text: 'Address Line 3' },
        { key: 'address.line4', text: 'Address Line 4' },
        { key: 'address.line5', text: 'Address Line 5' },
        { key: 'address.postCode', text: 'Post Code' },
        { key: 'address.country.description', text: 'Country' },
      ],
    },
    text: 'Contact Address',
  },
  {
    key: 'customerSubMenu',
    subMenuProps: {
      items: [
        { key: 'customer.reference', text: 'Reference' },
        { key: 'customer.name', text: 'Name' },
      ],
    },
    text: 'Customer',
  },
  ...companyAddressMenu,
  ...systemMenu,
];

export const salesDocument: Array<IContextualMenuItem> = [
  ...customerDocument,
  {
    key: 'amount',
    text: 'Goods Total',
  },
  {
    key: 'deliveryName',
    text: 'Shipment Name',
  },
  {
    key: 'deliveryAddress',
    text: 'Shipment Address',
  },
  {
    key: 'orderReference',
    text: 'Order Reference',
  },
  {
    key: 'salesOrderNumber',
    text: 'Sales Order Number',
  },
];

export const supplierDocument: Array<IContextualMenuItem> = [
  ...document,
  {
    key: 'supplierReference',
    text: 'Supplier Reference',
  },
  {
    key: 'supplierName',
    text: 'Supplier Name',
  },
];

export const purchaseDocument: Array<IContextualMenuItem> = [
  ...supplierDocument,
  {
    key: 'deliveryName',
    text: 'Delivery Name',
  },
  {
    key: 'deliveryAddress',
    text: 'Delivery Address',
  },
  {
    key: 'orderReference',
    text: 'Order Reference',
  },
];

export default def;
